var React = require('react');

function CircleHalfFilled8x8 (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M4 1a3 3 0 000 6z","fill":"currentColor","key":0}),React.createElement("circle",{"cx":"4","cy":"4","r":"3","stroke":"currentColor","strokeWidth":"2","fill":"none","key":1})]);
}

CircleHalfFilled8x8.defaultProps = {"width":"8","height":"8","viewBox":"0 0 8 8"};

module.exports = CircleHalfFilled8x8;

CircleHalfFilled8x8.default = CircleHalfFilled8x8;
